import { all, put, select, take } from 'redux-saga/effects';
import { getPropertyObjects } from '../redux/actions';
import { PROPERTY_OBJECTS_SUCCESS } from '../redux/actionTypes';
import { selectDraft } from 'modules/Taps/components/NDFL3Light/selectors';
import {
  starStepFetching,
  stopStepFetching,
} from 'modules/Taps/components/NDFL3Light/redux/actions';

export function* initIncomesSaga() {
  const draft = yield select(selectDraft);

  yield put(starStepFetching());

  yield all([
    put(
      getPropertyObjects({
        year: draft.getIn(['payload', 'initialData', 'reportYear']),
        isDefault: true,
      }),
    ),
    put(
      getPropertyObjects({
        year: draft.getIn(['payload', 'initialData', 'reportYear']),
        isDefault: false,
      }),
    ),
  ]);

  yield take([PROPERTY_OBJECTS_SUCCESS, PROPERTY_OBJECTS_SUCCESS]);

  yield put(stopStepFetching());
}
